import { Navigate, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";
import RedirectToHome from "./Pages/RedirectToHome";

// Lazy load the components
const RealStatesLandingIndex = lazy(() => import("./Pages/RealStates/RealStateLandingIndex"));
const VehicleLandingIndex = lazy(() => import("./Pages/Vehicles/VehicleLandingIndex"));

export const landingRouteList = [
  <Route key="landingRouteList">
    <Route path="/ExternalLoginCallback" element={<RedirectToHome/>} />
    <Route
      path="/"
      element={
        <Suspense fallback={<GeneralLoadingSpinner/>}>
          <RealStatesLandingIndex />
        </Suspense>
      }
    />
   
    <Route
      path="/vitrin/arac"
      element={
        <Suspense fallback={<GeneralLoadingSpinner/>}>
          <VehicleLandingIndex />
        </Suspense>
      }
    />
  </Route>,
];
